var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSource(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 21H5.30002C5.06133 21 4.83241 20.9052 4.66363 20.7364C4.49485 20.5676 4.40002 20.3387 4.40002 20.1V3.9C4.40002 3.66131 4.49485 3.43239 4.66363 3.2636C4.83241 3.09482 5.06133 3 5.30002 3H19.7C19.9387 3 20.1676 3.09482 20.3364 3.2636C20.5052 3.43239 20.6 3.66131 20.6 3.9V20.1C20.6 20.3387 20.5052 20.5676 20.3364 20.7364C20.1676 20.9052 19.9387 21 19.7 21ZM8.00002 6.6V10.2H11.6V6.6H8.00002ZM8.00002 12V13.8H17V12H8.00002ZM8.00002 15.6V17.4H17V15.6H8.00002ZM13.4 7.5V9.3H17V7.5H13.4Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSource);
export default __webpack_public_path__ + "static/media/source.1c56a804e0069d74a43a87dd6fa318f6.svg";
export { ForwardRef as ReactComponent };